<template>
  <div class="select-style" ref="langSelectorContainer" id="lang-selector-container">
    <select ref="langSelector" id="lang-selector" :name="$t('message.languageMenu')" :aria-label="$t('message.languageMenu')" @change="setLanguage()" v-model="lang">
      <option value="en">English</option>
      <option value="hi">हिंदी</option>
    </select>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import eventTracker from '../services/eventTracker'

  const messages = {
    en: {
      message: {
        languageMenu: 'Select language'
      }
    },
    hi: {
      message: {
        languageMenu: 'भाषा चुनिए'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    data () {
      return {
        lang: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en'
      }
    },
    props: {
      borderColor: {
        type: String,
        default: '#FFFFFF'
      },
      backgroundColor: {
        type: String,
        default: '#008577'
      }
    },
    methods: {
      setLanguage () {
        if (this.lang === 'en') {
          i18n.locale = 'en'
        } else if (this.lang === 'hi') {
          i18n.locale = 'hi'
        }

        this.$emit('languageChanged', i18n.locale)

        eventTracker.trackLanguageChange(i18n.locale)

        if (typeof (Storage) !== 'undefined') {
          localStorage.setItem('userLang', i18n.locale)
        }
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.$refs.langSelectorContainer.style.borderColor = this.$props.borderColor
        this.$refs.langSelector.style.backgroundColor = this.$props.backgroundColor
        this.$refs.langSelector.style.color = this.$props.borderColor
      })
    },
    watch: {
      borderColor: function (newBorderColor) {
        this.$refs.langSelectorContainer.style.borderColor = newBorderColor
        this.$refs.langSelector.style.color = newBorderColor
      },
      backgroundColor: function (newBackgroundColor) {
        this.$refs.langSelector.style.backgroundColor = newBackgroundColor
      }
    }
  }
</script>

<style scoped>
  .select-style {
    border: 3px solid var(--text-color-primary);
    width: 80px;
    border-radius: 20px;
    overflow: hidden;
  }

  .select-style select {
      padding: 5px 8px;
      color: var(--text-color-primary);
      width: 130%;
      border: none;
      box-shadow: none;
      background: var(--color-primary);
      background-image: none;
      -webkit-appearance: none;
  }

  .select-style select:focus {
      outline: none;
  }

  #lang-selector:focus {
    background-color: #000000;
  }
</style>




// WEBPACK FOOTER //
// src/components/LanguageSelectorComponent.vue